import { createStateSelectorHook } from 'src/lib/sweetState';

import { MainStore } from './MainStore';

const useState = createStateSelectorHook(MainStore, ['project']);

export const useProject = () => {
  const state = useState();
  return state.project;
};
